import { render, staticRenderFns } from "./InvoiceDocument.vue?vue&type=template&id=644ac817"
import script from "./InvoiceDocument.vue?vue&type=script&lang=ts"
export * from "./InvoiceDocument.vue?vue&type=script&lang=ts"
import style0 from "./InvoiceDocument.vue?vue&type=style&index=0&id=644ac817&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports